<template lang="pug">
div
  main
    .page-content
      .marginTop
        relatorio-cards-processo
        app-listagem-relatorio
</template>

<script>
import RelatorioCardsProcesso from '@/screens/relatorios/gerais/RelatorioCardsProcessos.vue'
import AppListagemRelatorio from '@/screens/relatorios/components/gerais/AppListagemRelatorio.vue'

export default {

  components: {
    RelatorioCardsProcesso,
    AppListagemRelatorio
  },

  data () {
    return {
      showModal: false
    }
  }

}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/_variables.scss';
.title {
  color: $color-primary;
}

.margin-top {
  margin-top: 10px;
}

/* Modal */
/deep/ .el-tabs--border-card {
  border-bottom: 0;
}

/deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  font-size: 16px;
  height: auto;
}

.marginTop {
  margin-top: 23px;
}

.marginTopMain {
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/screens/relatorios/gerais/Gerais.vue